import './i18n'
import './styles/app.scss'

import React from 'react'
import { createRoot } from 'react-dom/client'
import App from './app/app'
import AppProviders from './contexts/appProviders'
import { SENTRY_DSN } from './envConfig'
import addSentry from './utils/addSentry'

if (SENTRY_DSN) {
  addSentry()
}

createRoot(document.getElementById('root') as HTMLDivElement).render(
  <React.StrictMode>
    {/* Suspense for the case when translations are not yet loaded. Not in use because localizations are immediately loaded*/}
    {/*<Suspense fallback="...is loading">*/}
    <AppProviders>
      <App />
    </AppProviders>
    {/*</Suspense>*/}
  </React.StrictMode>,
)
